import React, { useEffect } from 'react';
import './LoadingScreen.css';

const LoadingScreen = ({ backgroundColor }) => {
  // Используем backgroundColor из пропсов, или черный по умолчанию, если не передан
  const screenStyle = {
    backgroundColor: backgroundColor || '#000000', // Черный фон по умолчанию
  };

  // Добавляем haptic feedback при загрузке
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg && tg.HapticFeedback) {
      // Создаем плавную последовательность вибраций
      // Начинаем с легкой вибрации
      tg.HapticFeedback.impactOccurred('soft');

      setTimeout(() => {
        tg.HapticFeedback.impactOccurred('soft');
      }, 100);

      setTimeout(() => {
        tg.HapticFeedback.impactOccurred('soft');
      }, 150);

      setTimeout(() => {
        tg.HapticFeedback.impactOccurred('soft');
      }, 100);

      setTimeout(() => {
        tg.HapticFeedback.impactOccurred('soft');
      }, 100);

      setTimeout(() => {
        tg.HapticFeedback.impactOccurred('soft');
      }, 100);

      setTimeout(() => {
        tg.HapticFeedback.impactOccurred('soft');
      }, 150);


    }
  }, []); // Запускаем только при монтировании компонента

  return (
    <div className="loading-screen" style={screenStyle}>
      <div className="loading-logo-container">
        <img 
          src="/uploads/logos/logo.svg" // Прямой путь к логотипу
          alt="Loading Logo" 
          className="loading-logo"
          // Логика isLogoLoaded здесь больше не нужна, так как CSS должен справиться
          // или мы предполагаем, что логотип достаточно мал для быстрой загрузки
        />
      </div>
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingScreen;
